import { vModelRadio as _vModelRadio, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ways-variants" }
const _hoisted_2 = /*#__PURE__*/_createVNode("label", { for: "one-way" }, "В одну сторону", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { for: "two-ways" }, "В обе стороны", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { for: "complex-way" }, "Сложный маршрут", -1)
const _hoisted_5 = { class: "search-form" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_searh_avia_element = _resolveComponent("searh-avia-element")
  const _component_search_params = _resolveComponent("search-params")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("form", _hoisted_1, [
      _withDirectives(_createVNode("input", {
        type: "radio",
        name: "way",
        id: "one-way",
        value: "one-way",
        checked: "",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.wayType = $event))
      }, null, 512), [
        [_vModelRadio, _ctx.wayType]
      ]),
      _hoisted_2,
      _withDirectives(_createVNode("input", {
        type: "radio",
        name: "way",
        id: "two-ways",
        value: "two-ways",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.wayType = $event))
      }, null, 512), [
        [_vModelRadio, _ctx.wayType]
      ]),
      _hoisted_3,
      _withDirectives(_createVNode("input", {
        type: "radio",
        name: "way",
        id: "complex-way",
        value: "complex-way",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.wayType = $event))
      }, null, 512), [
        [_vModelRadio, _ctx.wayType]
      ]),
      _hoisted_4
    ]),
    _createVNode("form", _hoisted_5, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.searhcData.migrationList, (item, index) => {
        return (_openBlock(), _createBlock(_component_searh_avia_element, {
          key: index,
          item: item,
          index: index,
          setData: _ctx.setData,
          setDataToIn: _ctx.setDataToIn,
          searchData: _ctx.searchData,
          wayType: _ctx.wayType,
          addRoute: _ctx.addRoute,
          deleteRoute: _ctx.deleteRoute,
          startHour: _ctx.searhcData.migrationList[index].startHour,
          endHour: _ctx.searhcData.migrationList[index].endHour,
          disabledSearch: _ctx.disabledSearch
        }, null, 8, ["item", "index", "setData", "setDataToIn", "searchData", "wayType", "addRoute", "deleteRoute", "startHour", "endHour", "disabledSearch"]))
      }), 128 /* KEYED_FRAGMENT */)),
      _createVNode("a", {
        href: "#",
        class: "login-restore-link",
        onClick: _cache[4] || (_cache[4] = _withModifiers($event => (_ctx.isParamsOpen = !_ctx.isParamsOpen), ["prevent"]))
      }, "Все параметры"),
      (_ctx.isParamsOpen)
        ? (_openBlock(), _createBlock(_component_search_params, {
            key: 0,
            isOnlyDirect: _ctx.searhcData.isOnlyDirect,
            setDirectFlight: _ctx.setDirectFlight,
            increaseCount: _ctx.increaseCount,
            decreaseCount: _ctx.decreaseCount,
            adultsCount: _ctx.searhcData.adults,
            childrenCount: _ctx.searhcData.children,
            infantsCount: _ctx.searhcData.infants,
            fare: _ctx.searhcData.fare,
            changeFare: _ctx.changeFare,
            faresList: _ctx.faresList
          }, null, 8, ["isOnlyDirect", "setDirectFlight", "increaseCount", "decreaseCount", "adultsCount", "childrenCount", "infantsCount", "fare", "changeFare", "faresList"]))
        : _createCommentVNode("", true)
    ])
  ]))
}